//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'
import ValidationTypeTag from '@/components/Projects/Detail/Tabs/SupervisorValidation/ValidationTypeTag.vue'

export default {
  components: { ModalWithTitleBar, ValidationTypeTag },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    collaborator: {
      type: Object,
      default: () => ({}),
    },
    supervisor: {
      type: Object,
      default: () => ({}),
    },
    skillsValidations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: this.value,
    }
  },
  computed: {
    collaboratorName() {
      return `${this.collaborator.names} ${this.collaborator.lastnames}`
    },
    supervisorName() {
      return `${this.supervisor.names} ${this.supervisor.lastnames}`
    },
  },
  watch: {
    value(newValue) {
      this.visible = newValue
    },
    visible(newValue) {
      this.$emit('input', newValue)
    },
  },
  methods: {
    onToggle() {
      this.visible = !this.visible
    },
  },
}
